// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__17Sk3","head":"Table_head__1zPV7","col":"Table_col__2Kwsr"};